export const DASHBOARD_LIST = "DASHBOARD_LIST";
